import React from "react";
import Header from "../layouts/Header";
import "./about.css";
import Footer from "../layouts/Footer";
export default function About() {
  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section className="about-hero">
        <div className="about-hero-overlay">
          <h1>About Bizzmark</h1>
          <p>Smart business discovery & lead generation platform</p>
        </div>
      </section>

      {/* CONTENT SECTION */}
      <section className="about-content">
        <div className="about-container">

          {/* LEFT CONTENT */}
          <div className="about-text">
            <h2>What is Bizzmark?</h2>
            <p>
              <strong>Bizzmark</strong> is a modern digital marketplace designed
              to connect customers with local and professional businesses in a
              simple, transparent, and efficient way. We help users discover
              services based on location, category, and real demand.
            </p>

            <p>
              Instead of endless searching, Bizzmark allows customers to
              directly connect with businesses through instant enquiries,
              WhatsApp communication, and verified listings. For businesses,
              we provide a powerful platform to showcase services and receive
              genuine leads.
            </p>

            <h3>Our Purpose</h3>
            <p>
              To create a trusted ecosystem where businesses grow through
              meaningful customer connections and users find the right
              service without confusion or delay.
            </p>

            <h3>Our Vision</h3>
            <p>
              To become a leading digital business discovery platform that
              empowers local businesses with visibility, credibility, and
              measurable growth.
            </p>
          </div>

          {/* RIGHT INFO BOX */}
          <div className="about-info-box">
            <h3>Why Bizzmark?</h3>

            <ul>
              <li>✔ Business-focused listings, not advertisements</li>
              <li>✔ Direct WhatsApp & call enquiries</li>
              <li>✔ Location & category based discovery</li>
              <li>✔ Simple lead generation for businesses</li>
              <li>✔ Clean, fast & user-friendly platform</li>
            </ul>

            <div className="about-stats">
              <div>
                <h4>Growing</h4>
                <span>Business Network</span>
              </div>
              <div>
                <h4>Multiple</h4>
                <span>Service Categories</span>
              </div>
              <div>
                <h4>Pan India</h4>
                <span>Expansion Plan</span>
              </div>
            </div>
          </div>

        </div>
      </section>

        {/* ================= EXTRA INFO SECTION ================= */}
{/* ================= EXTRA INFO SECTION ================= */}
<section className="about-extra">
  <div className="about-extra-grid">

    {/* LEFT */}
    <div className="about-block">
      <h3>🎯 Bizzmark’s Mission</h3>
      <p>
        Our mission is to make business discovery simple, transparent, and
        action-oriented. Bizzmark helps users quickly find the right services
        while enabling businesses to connect with genuine customers through
        smart digital tools.
      </p>
    </div>

    {/* RIGHT */}
    <div className="about-block">
      <h3>🏢 Corporate Information</h3>
      <p>
        Bizzmark was built to modernize local business discovery using
        location-based search and direct enquiry systems.
      </p>
      <p>
        The platform focuses on verified listings and meaningful customer
        interactions instead of paid advertisements.
      </p>
      <p>
        Bizzmark operates as a digital marketplace connecting users and
        service providers across multiple business categories.
      </p>
      <p>
        Our services are accessible through web and mobile-friendly platforms.
      </p>
    </div>

  </div>

  {/* FULL WIDTH */}
  <div className="about-block about-block-full">
    <h3>📊 Bizzmark Facts</h3>
    <ul>
      <li>Designed for fast search and instant WhatsApp enquiries</li>
      <li>Supports local, professional, and on-demand services</li>
      <li>Built for scalability across cities and regions</li>
    </ul>
  </div>
</section>

    {/* ================= KEY HIGHLIGHTS ================= */}
{/* ================= KEY HIGHLIGHTS ================= */}
<section className="about-highlights">
  <div className="highlights-container">

    {/* LEFT */}
    <div className="highlights-title">
      <h2>✨ Key Highlights</h2>
    </div>

    {/* RIGHT */}
    <div className="highlights-content">
      <ul>
        <li>
          <strong>Pan-India Reach:</strong> Bizzmark supports businesses and
          customers across multiple cities, enabling scalable nationwide growth.
        </li>

        <li>
          <strong>Business-first Platform:</strong> Designed to generate genuine
          enquiries instead of pushing paid visibility.
        </li>

        <li>
          <strong>Smart & Scalable Technology:</strong> Location-based discovery,
          category-driven search, and instant WhatsApp communication.
        </li>

        <li>
          <strong>Engaged User Network:</strong> A growing community actively
          searching and connecting with businesses in real time.
        </li>

        <li>
          <strong>Strong Value for MSMEs:</strong> Digital presence, lead
          generation, and customer engagement tools for small businesses.
        </li>

        <li>
          <strong>Local Market Understanding:</strong> Built around real local
          business needs for better visibility and repeat customers.
        </li>

        <li>
          <strong>Growth-driven Vision:</strong> Long-term scalability with
          trust, transparency, and sustainable growth.
        </li>
      </ul>
    </div>

  </div>
</section>

<Footer />

    </>
  );
}
